import { render } from "./PartnerPeac.vue?vue&type=template&id=5b4a84c2"
import script from "./PartnerPeac.vue?vue&type=script&lang=js"
export * from "./PartnerPeac.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__